import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'lp2-circle-close-button',
  templateUrl: './circle-close-button.component.html',
  styleUrls: ['./circle-close-button.component.scss']
})
export class CircleCloseButtonComponent {
  @Output() close: EventEmitter<any> = new EventEmitter();

  onClose(event: any) {
    this.close.emit(event);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/circle-close-button/circle-close-button.component.ts